export const formatDate = (date)=>{
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return dateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};
export const parseDateInput = (dateString)=>{
    if (!dateString) return undefined;
    const dateOnlyMatch = dateString.match(/^\d{4}-\d{2}-\d{2}/);
    if (!dateOnlyMatch) return undefined;
    const dateOnly = dateOnlyMatch[0];
    const date = new Date(`${dateOnly}T00:00:00`);
    return isNaN(date.getTime()) ? undefined : date;
};
export var DateInputValueFormat;
(function(DateInputValueFormat) {
    DateInputValueFormat["DateOnly"] = "date-only";
    DateInputValueFormat["Rfc3339StartOfDay"] = "rfc3339-start-of-day";
    DateInputValueFormat["Rfc3339EndOfDay"] = "rfc3339-end-of-day";
})(DateInputValueFormat || (DateInputValueFormat = {}));
export const formatDateInput = (date, valueFormat = "date-only")=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dateOnly = `${year}-${month}-${day}`;
    switch(valueFormat){
        case "rfc3339-start-of-day":
            return `${dateOnly}T00:00:00Z`;
        case "rfc3339-end-of-day":
            return `${dateOnly}T23:59:59Z`;
        case "date-only":
            return dateOnly;
    }
    return dateOnly;
};
